/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum models_GenderType {
    GenderMale = 'MALE',
    GenderFemale = 'FEMALE',
    GenderOther = 'OTHER',
    GenderUnknown = 'UNKNOWN',
    GenderUndefined = 'UNDEFINED',
}
